// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2UYYW","infoBtn":"quickbooks_infoBtn__2cZ9l","formBox":"quickbooks_formBox__1UQml","formFooter":"quickbooks_formFooter__1yxQs"};